const NO_COVERAGE_SELECTED = 'no coverage selected'

export function getSelectedLevel(
  benefit: any,
  levelSelections: Record<string, string> = {}
) {
  const overrideLevelId = levelSelections[benefit?.id]
  const levels: any[] = benefit?.levels || []
  const fallback = levels.find(l => l.isSelected)
  if (!overrideLevelId) return fallback
  return levels.find(l => l.id === overrideLevelId) ?? fallback
}

function hasNoCoverageSelectedText(value = '') {
  return String(value).toLowerCase().includes(NO_COVERAGE_SELECTED)
}

function isZeroPriceLevel(level: any) {
  const amount = String(level.amount ?? '').trim()
  return amount === '0' || amount === '0.00'
}

export function getExternalPlanTotal(
  plan: any,
  levelSelections: Record<string, string> = {}
): number {
  if (!plan) return 0
  return plan.products
    .flatMap((p: any) => p.benefits || [])
    .reduce(
      (sum: number, benefit: any) =>
        sum + (getSelectedLevel(benefit, levelSelections)?.price || 0),
      0
    )
}

interface ParseBenefitsOptions {
  suppressNoCoverageSelected?: boolean
  selectedLevels?: Record<string, string>
}

export const parseBenefits = (
  products: any[] = [],
  options: ParseBenefitsOptions = {}
) => {
  const { suppressNoCoverageSelected = false, selectedLevels = {} } = options

  return products
    .flatMap((product: any) => product?.benefits || [])
    .map(benefit => {
      const selected = getSelectedLevel(benefit, selectedLevels)
      if (!selected) return null

      if (suppressNoCoverageSelected) {
        const value = String(selected.description || '').trim()
        if (!value) return null
        if (isZeroPriceLevel(selected)) return null
        if (hasNoCoverageSelectedText(value)) return null
        if (hasNoCoverageSelectedText(benefit?.name)) return null
      }

      return { label: benefit.name, value: selected.description }
    })
    .filter(Boolean)
}

export function getSuppressedBenefitsCount(
  products: any[] = [],
  selectedLevels: Record<string, string> = {}
): number {
  return products
    .flatMap((product: any) => product?.benefits || [])
    .filter(benefit => {
      const selected = getSelectedLevel(benefit, selectedLevels)
      if (!selected) return false
      const value = String(selected.description || '').trim()
      return (
        !value ||
        isZeroPriceLevel(selected) ||
        hasNoCoverageSelectedText(value) ||
        hasNoCoverageSelectedText(benefit?.name)
      )
    }).length
}
